<template>
  <div class="qa-info container">
    <Header title="销售方电子质保"></Header>

    <div class="block-1"></div>

    <div class="info-box">
      <div class="info-box-item">
        <div class="title">博世料号：</div>
        <div class="text">{{codeInfo.partNo}}</div>
      </div>
      <div class="info-box-item">
        <div class="title">产品名称：</div>
        <div class="text">{{codeInfo.partName}}</div>
      </div>
      <div class="info-box-item">
        <div class="title">销售日期：</div>
        <div class="text">{{parseTime(codeInfo.initTime,'{y}-{m}-{d}')}}</div>
      </div>
    </div>

    <div class="input-info">
      <van-form error-message-align="right" :show-error="false" ref="selectedInput">
        <van-field
        v-model="codeInfo.workshopName"
        label="销售方名称"
        placeholder="请输入销售方名称"
        input-align="right"
        :rules="[{ validator:validatorEmpty, message: '请输入销售方名称'}]"
        />
        <van-field
        v-model="codeInfo.workshopAddress"
        label="销售方地址"
        placeholder="请输入销售方地址"
        input-align="right"
        :rules="[{  validator:validatorEmpty, message: '请输入销售方地址' }]"
        />
        <van-field
        v-model="codeInfo.workshopPerson"
        label="销售/安装人员"
        placeholder="请输入销售/安装人员"
        input-align="right"
        :rules="[{  validator:validatorEmpty, message: '请输入销售/安装人员' }]"
        />
        <div style="height:10px"></div>
        <!-- <van-field
        v-model="codeInfo.consumerMobile"
        label="车主手机号"
        type="tel"
        placeholder="请输入车主手机号"
        input-align="right"
        :rules="[{  validator:validatorMobile, message: '请输入合法手机号'}]"
        /> -->
        <van-field
        v-model="initMileage"
        type="number"
        label="安装时里程数"
        placeholder="请输入安装时里程数"
        input-align="right"
        @blur="handleInitMileage"
        :rules="[{validator:validatorKM, message: '请输入大于0的数字'}]"
        >
          <template #extra>
            <div>&nbsp;KM</div>
          </template>
        </van-field>
      </van-form>

      <van-cell-group :class="hasCarInfo?'spBlack':'spGrey'">
        <van-cell title="车型" :value="carName">
          <template #right-icon>
            <van-uploader
              v-model="files"
              :preview-image="false"
              :before-read="beforeRead"
              :after-read="fileSubmitted"
              >
              <div>&nbsp;<van-icon name="photograph" size="23" class="search-icon" /></div>
            </van-uploader>
          </template>
        </van-cell>
      </van-cell-group>

      <div class="tip-right">
        (请对准vin码)
      </div>

      <div class="privacy">
          <van-checkbox v-model="privacy"  name="true">我已阅读并同意</van-checkbox>
          <span class="link" @click="showPrivacy">隐私条款</span>
      </div>
    </div>

    <div class="block-2"></div>

    <div class="footer">
      <div v-points class="btn submit-btn" @click="submit()">提交</div>
    </div>

  </div>
</template>

<script>
import Header from '../../../components/header.vue'
import { commonUtils } from '@/utils/common'
import activityApi from '@/api/activity'
import Compress from 'compress.js'
import cartApi from '@/api/cart'
export default {
  components: { Header },
  data () {
    return {
      code: '',
      codeInfo: {},
      initMileage: '',
      files: [],
      carName: '请上传图片识别VIN码',
      hasCarInfo: false,
      privacy: false
    }
  },
  created () {
    this.getCodeInfo()
    if (this.$route.query.warrantyStatus && this.$route.params.from === 'list') {
      this.$dialog.alert({
        title: '提示',
        message: '该保单已被激活，前往保单详情页查看！'
      })
        .then(() => {
          if (this.$route.query.scanAdd) {
            this.$router.push({ name: 'quality-assurance-ws-feedback', query: { warrantyId: this.$route.query.warrantyId, scanAdd: this.$route.query.scanAdd } })
          } else {
            this.$router.push({ name: 'quality-assurance-ws-feedback', query: { warrantyId: this.$route.query.warrantyId } })
          }
        })
        .catch(() => {
          // on cancel
        })
    }
  },
  mounted () {
    if (this.codeInfo.carName) {
      this.carName = this.codeInfo.carName
      this.hasCarInfo = true
      this.privacy = true
    }
  },
  methods: {
    parseTime: commonUtils.parseTime,
    getCodeInfo () {
      let data = sessionStorage.getItem('codeInfo') || ''
      this.codeInfo = JSON.parse(data)
      console.log(this.codeInfo)
    },
    validatorKM (val) {
      let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g
      if ((reg.test(val) && Number(val) > 0)) return true
      return false
    },
    validatorEmpty (val) {
      let reg = /^[\s]*$/
      if ((reg.test(val))) return false
      return true
    },

    validatorMobile (val) {
      let reg = /^(1[3|4|5|6|7|8|9][0-9]\d{8})$/
      if (reg.test(val) || val === '') return true
      return false
    },
    CarnivalSubmit () {
      let that = this
      let wxUserInfo = JSON.parse(localStorage.getItem('userInfo'))
      console.log('wxUserInfo=================', wxUserInfo)
      let data = {
        clientId: wxUserInfo.clientInfo.clientId,
        clientUserId: wxUserInfo.clientInfo.clientUserId,
        activityKey: 'firstActivationBattery'
      }
      cartApi.CarnivalSubmit(data).then(ress => {
        console.log('res===', ress)
        let res = ress.data
        if (res.resultData && res.resultData.msg) {
          console.log('res===', res.resultData.msg)
          that.$toast.success(res.resultData.msg)
        }
      })
    },
    submit () {
      this.$refs.selectedInput.validate().then(res => {
        if (!this.privacy && this.carName !== '请上传图片识别VIN码') {
          this.$toast.fail('请阅读并同意关于VIN的隐私条款')
          return
        }
        this.codeInfo.initMileage = this.initMileage
        if (this.codeInfo.warrantyId) {
          this.warrantyId = this.codeInfo.warrantyId
          activityApi.updateCodeInfo(this.codeInfo).then(res => {
            if (res.data.resultCode === '0') {
              let data = JSON.stringify(this.codeInfo)
              sessionStorage.setItem('codeInfo', data)
              this.gotoWeb('update')
            }
          })
        } else {
          activityApi.submitCodeInfo(this.codeInfo).then(res => {
            if (res.data.resultCode === '0') {
              let data = JSON.stringify(res.data.resultData.warrantyInfo)
              sessionStorage.setItem('codeInfo', data)
              this.warrantyId = data.warrantyId
              console.log(res.data.resultCode)
              this.gotoWeb('submit')
              this.CarnivalSubmit()
            }
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    gotoWeb (type) {
      if (this.$route.query.scanAdd) {
        this.$router.push({ name: 'quality-assurance-ws-result', query: { type: type, warrantyId: this.warrantyId, scanAdd: '1' } })
      } else {
        this.$router.push({ name: 'quality-assurance-ws-result', query: { type: type, warrantyId: this.warrantyId } })
      }
    },
    handleInitMileage () {
      if (this.initMileage !== '' && this.initMileage !== '0') {
        let distance = Number(this.initMileage).toFixed(2)
        this.initMileage = distance
      } else {
        this.initMileage = ''
      }
    },
    beforeRead () {
      if (!this.privacy) {
        this.$toast.fail('请阅读并同意关于VIN的隐私条款')
        return false
      }
      this.files = []
      return true
    },
    fileSubmitted (file) {
      if (file.file.size < 1024 * 1024 * 3) {
        this.recognizeVin(file)
      } else {
        const compress = new Compress()
        compress.compress([file.file], {
          size: 4,
          quality: 0.75,
          maxWidth: 2000,
          maxHeight: 2000,
          resize: true
        }).then(results => {
        // console.log(results)
          const img = results[0]
          const base64Str = img.prefix + img.data
          const fileObj = commonUtils.convertBase64ToFile(base64Str, file.file.name)
          const compressedFile = {
            content: base64Str,
            file: fileObj
          }
          console.log(compressedFile)
          if (compressedFile.file.size > this.imageSizeLimit) {
            this.$toast('上传图片不能大于3M')
          } else {
            this.recognizeVin(compressedFile)
          }
        })
      }
    },
    recognizeVin (file) {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '正在识别...'
      })
      activityApi.queryCarByVinImg({ imageBase64Data: file.content }).then(response => {
        toast.clear()
        if (response.data.resultCode === '0') {
          let vinCode = response.data.resultData.vinCode
          let params = {
            vinCode
          }
          activityApi.getCarName(params).then(res => {
            if (res.data.resultCode === '0') {
              this.codeInfo.vinCode = vinCode
              if (!this.codeInfo.warrantyId) {
                this.codeInfo.carId = res.data.resultData.carInfoList[0].carId
              }
              this.carName = res.data.resultData.carInfoList[0].carFullInfo
              this.codeInfo.carName = this.carName
              this.hasCarInfo = true
            } else {
              // this.carName = '请上传图片识别VIN码'
              // delete this.codeInfo.carName
              this.carName = vinCode
              this.codeInfo.carName = vinCode
              this.hasCarInfo = true
            }
          }).catch(err => {
            console.log(err)
            // this.carName = '请上传图片识别VIN码'
            // delete this.codeInfo.carName
            this.carName = vinCode
            this.codeInfo.carName = vinCode
            this.hasCarInfo = true
          })
        } else {
          this.carName = '请上传图片识别VIN码'
          delete this.codeInfo.carName
          this.hasCarInfo = false
        }
      }).catch(err => {
        toast.clear()
        console.log(err)
        this.carName = '请上传图片识别VIN码'
        delete this.codeInfo.carName
        this.hasCarInfo = false
      })
    },
    showPrivacy () {
      this.$router.push({ name: 'privacy', home: false })
    }
  }
}
</script>

<style lang="less" scoped>
@media (max-height: 450px){
  .footer {
    position: static !important;
  }
  .block-2{
    width: 100%;
    height: 80px;
  }
}
@media (min-width: 450px){
  .block-2{
    width: 100%;
    height: 80px;
  }
}
  .block-2{
    width: 100%;
    height: 70px;
  }
html,body{
    position:relative;
    height:100%;
    min-height:100%;
}
.container{
  background: url('../../../assets/images/extra-logo.png');
  background-size: 100% 200px;
  background-repeat: no-repeat;
  background-position-y: 46px;
}
.block-1{
  height: 216px;
}
.info-box{
  position: relative;
  padding: 10px 0;
 // margin: 20px;
  margin: 0 20px;
  background-color: white;
  border-radius: 3px;
}
.btn{
  position: relative;
  margin:0 10px;
  top: 10px;
  text-align: center;
  border-radius: 3px;
  color: white;
  background-color: rgb(17, 114, 129);
  padding: 12px;
}
.footer{
  width: 100vw;
  height: 60px;
  background-color: white;
  position: fixed;
  bottom: 0px;
}
.info-box-item{
  padding: 8px 10px ;
  display: flex;
  color: gray;
  .title{
    width: 70px;
    word-break: keep-all;
  }
}
.input-info{
  margin-top: 20px;
}
.van-field__label{
  width: 13rem;
}
.spGrey .van-cell__value{
  color: #d1d1d1;
}
.spBlack .van-cell__value{
  color: #000000;
}
.van-cell__value{
  min-width: 230px;
}
.privacy{
  display: flex;
  background-color: white;
  padding:5px 15px 15px 15px;
  width: calc(100% - 30px);
  .link{
    color: rgb(39, 148, 211);
    text-decoration: underline;
    line-height: 21px;
    margin-left: 10px;
  }
}
  .tip-right{
    font-size: 12px;
    line-height: 20px;
    color: #999;
    width:calc(100vw - 20px);
    background-color: #fff;
    padding:0 10px;
    text-align: right;
  }
</style>
